import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import './assets/main.css';

import { createApp } from 'vue'
import App from './App.vue'
import './tailwind.css'
import "flowbite";
import { router } from './router/router';
import { createPinia } from "pinia";

const pinia = createPinia();

createApp(App)
.provide("bootstrap", bootstrap)
.use(router)
.use(pinia)
.mount('#app')
